import i18n from "@/libs/i18n/i18n";
import { GluestackUIProvider } from "@leplein/ui";
import { PropsWithChildren } from "react";
import { I18nextProvider } from "react-i18next";
import { CrispProvider } from "./CrispProvider/CrispProvider";
import { GestureHandlerProvider } from "./GestureHandlerProvider/GestureHandlerProvider";
import { StyleRegistryProvider } from "./StyleRegistryProvider/StyleRegistryProvider";

interface Props extends PropsWithChildren {}

export const Providers = ({ children }: Props) => (
	<I18nextProvider i18n={i18n}>
		<CrispProvider>
			<StyleRegistryProvider>
				<GestureHandlerProvider>
					<GluestackUIProvider mode="light">{children}</GluestackUIProvider>
				</GestureHandlerProvider>
			</StyleRegistryProvider>
		</CrispProvider>
	</I18nextProvider>
);
